package com.klantenstop.web.data.models.dto.responses.moderation

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ModerationQueueDto(
    val items: List<ModerationEntryDto> = emptyList(),
    val total: Long = 0,
    val page: Int = 1,
    @SerialName("page_size")
    val pageSize: Int = 20,
)
